var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGridview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6455",
    "data-name": "Path 6455",
    d: "M3.368.842V3.368H.842V.842ZM4.211,0H0V4.211H4.211ZM3.368,12.632v2.526H.842V12.632Zm.842-.842H0V16H4.211ZM3.368,6.737V9.263H.842V6.737Zm.842-.842H0v4.211H4.211ZM15.158.842V3.368H12.632V.842ZM16,0H11.79V4.211H16Zm-.842,6.737V9.263H12.632V6.737ZM16,5.895H11.79v4.211H16ZM9.263.842V3.368H6.737V.842ZM10.105,0H5.895V4.211h4.211ZM9.263,12.632v2.526H6.737V12.632Zm.842-.842H5.895V16h4.211ZM9.263,6.737V9.263H6.737V6.737Zm.842-.842H5.895v4.211h4.211Zm5.053,6.737v2.526H12.632V12.632ZM16,11.79H11.79V16H16Z",
    fill: "#393939"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridview);
export default __webpack_public_path__ + "static/media/gridview.3e668bc5297a20d4ee9c9c2f68dda39f.svg";
export { ForwardRef as ReactComponent };